import React from "react";

import DashboardNavigation from "../../DashboardNavigation/DashboardNavigation";
import ScrollIndicator from "../../Home/ScrollIndicator";
import useScrollToTop from "../../../hooks/useScollToTop";

import CoachGradeHero from "./components/CoachGradeHero";
import CoachGradeFilters from "./components/CoachGradeFilters";
import CoachGradeTable from "./components/CoachGradeTable";
import CoachGradeHistoryModal from "./components/CoachGradeHistoryModal";
import CoachGradeSkeleton from "./components/CoachGradeSkeleton";
import CoachGradeEmptyState from "./components/CoachGradeEmptyState";
import CoachGradeBulkBar from "./components/CoachGradeBulkBar";

import { usePassageGradeCoachPage } from "./hooks/usePassageGradeCoachPage";

function PassageGradeCoach() {
  useScrollToTop();

  const {
    groups,
    belts,
    filteredRows,
    filters,
    stats,
    selectedRow,
    selectedGrade,
    beltForm,
    loading,
    refreshing,
    savingBelt,
    deletingGradeId,
    isHistoryOpen,

    selectedAdherentIds,
    selectedRows,
    selectedFilteredRows,
    bulkBeltForm,
    savingBulkBelt,

    fetchData,
    updateFilters,
    resetFilters,
    openHistoryModal,
    closeHistoryModal,
    handleBeltInputChange,
    handleEditGrade,
    handleCancelGradeEdit,
    handleSubmitBelt,
    handleDeleteGrade,

    toggleSelectAdherent,
    selectAllFilteredRows,
    unselectAllFilteredRows,
    clearSelection,
    handleBulkBeltInputChange,
    handleSubmitBulkBelt,
  } = usePassageGradeCoachPage();

  const hasFilters = Boolean(
    filters.search || filters.groupId || filters.beltId
  );

  return (
    <main className="min-h-screen bg-slate-50 pb-40 text-slate-950 dark:bg-slate-950 dark:text-white">
      <CoachGradeHero
        stats={stats}
        refreshing={refreshing}
        onRefresh={() => fetchData({ silent: false })}
      />

      <section className="mx-auto -mt-12 w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">
        <CoachGradeFilters
          groups={groups}
          belts={belts}
          filters={filters}
          onChange={updateFilters}
          onReset={resetFilters}
        />
      </section>

      <section className="mx-auto mt-6 w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">
        {loading ? (
          <CoachGradeSkeleton />
        ) : filteredRows.length > 0 ? (
          <CoachGradeTable
            rows={filteredRows}
            selectedAdherentIds={selectedAdherentIds}
            selectedFilteredCount={selectedFilteredRows.length}
            onToggleSelect={toggleSelectAdherent}
            onSelectAllFiltered={selectAllFilteredRows}
            onUnselectAllFiltered={unselectAllFilteredRows}
            onOpenHistory={openHistoryModal}
          />
        ) : (
          <CoachGradeEmptyState
            hasFilters={hasFilters}
            onReset={resetFilters}
          />
        )}
      </section>

      <CoachGradeHistoryModal
        isOpen={isHistoryOpen}
        row={selectedRow}
        belts={belts}
        form={beltForm}
        selectedGrade={selectedGrade}
        saving={savingBelt}
        deletingGradeId={deletingGradeId}
        onClose={closeHistoryModal}
        onChange={handleBeltInputChange}
        onSubmit={handleSubmitBelt}
        onEdit={handleEditGrade}
        onCancelEdit={handleCancelGradeEdit}
        onDelete={handleDeleteGrade}
      />

      <CoachGradeBulkBar
        selectedCount={selectedRows.length}
        belts={belts}
        form={bulkBeltForm}
        saving={savingBulkBelt}
        onChange={handleBulkBeltInputChange}
        onSubmit={handleSubmitBulkBelt}
        onClear={clearSelection}
      />

      <DashboardNavigation />
      <ScrollIndicator />
    </main>
  );
}

export default PassageGradeCoach;